module.exports = __webpack_public_path__ + "assets/img/plan4-5.fb46d874.png";